import { $, exists, addClass, removeClass } from "../utils/dom.js";
import { createSwiperWithPreset } from "../utils/swiperConfig.js";

const DESKTOP_BREAKPOINT = 1024;

export const initTimelineScroll = () => {
  if (!exists("[data-timeline-scroll]")) {
    return;
  }

  const section = $("[data-timeline-scroll]");
  const swiperContainer = $(".timeline-slider-scroll__swiper", section);
  const wrapper = $(".timeline-slider-scroll__wrapper", section);

  const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

  let swiper = null;
  let scrollTriggerInstance = null;

  const initDesktop = () => {
    if (!swiperContainer || !wrapper) return;

    swiper = createSwiperWithPreset(
      ".timeline-slider-scroll__swiper",
      "timelineSlider",
      {
        speed: 400,
        allowTouchMove: false,
      }
    );

    const slideCount = swiper.slides.length;
    const pinDuration = (slideCount - 1) * window.innerHeight;

    let lastSlideIndex = 0;

    scrollTriggerInstance = ScrollTrigger.create({
      trigger: wrapper,
      start: "top top",
      end: `+=${pinDuration}`,
      pin: wrapper,
      pinSpacing: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const targetSlide = Math.round(progress * (slideCount - 1));

        if (targetSlide !== lastSlideIndex && swiper) {
          swiper.slideTo(targetSlide);
          lastSlideIndex = targetSlide;
        }
      },
      onEnter: () => {
        addClass(section, "timeline-slider-scroll--pinned");
      },
      onLeave: () => {
        removeClass(section, "timeline-slider-scroll--pinned");
      },
      onEnterBack: () => {
        addClass(section, "timeline-slider-scroll--pinned");
      },
      onLeaveBack: () => {
        removeClass(section, "timeline-slider-scroll--pinned");
      },
    });
  };

  const destroyDesktop = () => {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }

    if (scrollTriggerInstance) {
      scrollTriggerInstance.kill();
      scrollTriggerInstance = null;
    }

    removeClass(section, "timeline-slider-scroll--pinned");
  };

  const handleResize = () => {
    const wasDesktop = swiper !== null;
    const shouldBeDesktop = isDesktop();

    if (shouldBeDesktop && !wasDesktop) {
      initDesktop();
    } else if (!shouldBeDesktop && wasDesktop) {
      destroyDesktop();
    }

    if (scrollTriggerInstance && shouldBeDesktop) {
      ScrollTrigger.refresh();
    }
  };

  if (isDesktop()) {
    initDesktop();
  }

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 250);
  });
};
